import { Actions } from '@components/shared/Actions'
import { EditIcon } from '@assets/svgs/EditIcon'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { DetailedSummaryExpensesItemProps } from '../context/types'

interface ParseDetailedSummaryExpensesProps {
  data: DetailedSummaryExpensesItemProps[]
  actionsDisabled: boolean
  onEdit: (data: DetailedSummaryExpensesItemProps) => void
}

export const parseDetailedSummaryExpensesGrid = ({
  data,
  actionsDisabled,
  onEdit
}: ParseDetailedSummaryExpensesProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'accountingCode',
      columnName: 'Conta',
      align: 'center',
      value: item.accountingCode || '-',
      minWidth: '8rem',
      sortable: true
    },
    {
      id: 'accountingDescription',
      columnName: 'Descrição Conta',
      align: 'center',
      value: item.accountingDescription || '-',
      minWidth: '20rem',
      sortable: true
    },
    {
      id: 'otherExpensesAmount',
      columnName: 'Valor Outras Despesas (R$)',
      align: 'center',
      currency: true,
      value: item.otherExpensesAmount || 0,
      minWidth: '11rem',
      sortable: true
    },
    {
      id: 'observations',
      columnName: 'Observações',
      align: 'center',
      value: item.observations || '-',
      minWidth: '20rem',
      sortable: true
    },
    {
      id: 'action',
      columnName: 'Ações',
      align: 'center',
      minWidth: '5rem',
      maxWidth: '5rem',
      stickyPosition: 'right',
      withoutTooltip: true,
      value: (
        <Actions
          actions={[{ label: 'Editar', icon: <EditIcon />, onClick: () => onEdit(item) }]}
          disabled={actionsDisabled}
        />
      )
    }
  ])

  return parsedData
}
